import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { changeLanguage, currentLanguage$ } from "@a365/core";
import { Chip } from "@a365/dsys";

const SwitchLanguage = () => {
  const { t, i18n } = useTranslation();
  const [activeButton, setActiveButton] = useState({ 1: false, 2: false });

  // Efecto para detectar cambios en el idioma
  useEffect(() => {
    // Esta función actualiza el estado de los botones basado en el idioma actual
    const updateButtonState = () => {
      const currentLang = localStorage.getItem("lang") || "es";
      setActiveButton({
        1: currentLang === "es",
        2: currentLang === "pt",
      });
    };

    // Actualizar inmediatamente al montar
    updateButtonState();

    // Suscribirse al observable para detectar cambios de idioma
    const subscription = currentLanguage$.subscribe(() => {
      updateButtonState();
    });

    // Limpiar la suscripción al desmontar
    return () => subscription.unsubscribe();
  }, []);

  // También reaccionamos a cambios en i18n directamente por redundancia
  useEffect(() => {
    const currentLang = localStorage.getItem("lang") || "es";
    setActiveButton({
      1: currentLang === "es",
      2: currentLang === "pt",
    });
  }, [i18n.language]);  const handleLanguage = (lang) => {
    // Eliminar la condición problemática - siempre permitir el cambio
    if (lang === "es") {
      setActiveButton({ 1: true, 2: false });
    } else {
      setActiveButton({ 1: false, 2: true });
    }

    // Usar la función del core para cambiar el idioma
    changeLanguage(lang === "es" ? "es" : "pt-BR");
    // Cambiamos el idioma en i18n directamente para este componente
    i18n.changeLanguage(lang === "es" ? "es" : "pt-BR");

    // Legacy: Refrescar página si estamos en rutas específicas (reintegros express o ccgg)
    const currentPath = window.location.pathname;
    const isReintegrosExpressRoute = currentPath.includes("/reintegros-express");
    
    if (isReintegrosExpressRoute) {
      // Pequeño delay para asegurar que los cambios de idioma se guarden
      setTimeout(() => {
        window.location.reload();
      }, 100);
    }
  };

  return (
    <div className="switch-language-container text-base flex items-center">
      <span className="language-label pr-4 text-text-decorative-darker font-semibold block">
        {t("language")}
      </span>

      <div className="languages-wrapper flex space-x-2">
        <Chip
          size="small"
          state={activeButton[1] ? "selected" : "default"}
          onClick={() => handleLanguage("es")}
        >
          {t("spanish")}
        </Chip>
        <Chip
          size="small"
          onClick={() => handleLanguage("pt")}
          state={activeButton[2] ? "selected" : "default"}
        >
          {t("portuguese")}
        </Chip>
      </div>
    </div>
  );
};

export default SwitchLanguage;
